<template>
	<div v-if="Character.Equipment.Augmentation.length > 0">
		<h5 class="mt-2">Augmentations</h5>
		<b-table-simple responsive small bordered striped table-class="mb-0" class="mt-2">
			<b-thead>
				<b-tr>
					<b-th>System</b-th>
					<b-th>Augmentation</b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr v-for="(augment, index) in Character.Equipment.Augmentation" :key="'equipment-augments-'+index">
					<b-td>{{augment.System}}</b-td>
					<b-td>{{augment.Name}}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>